export const BASE_URL = process.env.REACT_APP_API_KEY;
// export const BASE_URL = 'http://178.128.61.122:8080';
// export const PROFILE_BASE_URL = process.env.REACT_APP_API_KEY;
// export const PROFILE_BASE_URL = 'http://178.128.61.122:8085';

export const CUSTOMER_FIND_MANY = BASE_URL + '/customer/register/find-many-profile';
export const COUNT_NUMBER_CUSTOMER = BASE_URL + '/customer/register/count-customer';
export const BAN_CUSTOMER = BASE_URL + '/customer/credentials/ban';
export const IMAGE_CUSTOMER = BASE_URL + '/profile/api/';

